import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import API from "./API";

(function() {
    const apiBaseURL = API.origin();
    if (apiBaseURL) {
        // console.log("Setting API baseURL to ", apiBaseURL);
        axios.defaults.baseURL = apiBaseURL;
        axios.defaults.withCredentials = true;
    }
})();

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOMClient.createRoot(container);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
